"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigningEntityRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.SigningEntityRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.signing_entity.label',
    fallbackLabel: 'Signing entity',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'COMPANY_SIGNING_THE_MOR_AGREEMENT_WITH_KLARNA', label: 'fields.enm.signing_entity.options.COMPANY_SIGNING_THE_MOR_AGREEMENT_WITH_KLARNA', fallbackLabel: 'The company signing the MoR-agreement with Klarna (your company)' },
        { key: 'DISTRIBUTOR', label: 'fields.enm.signing_entity.options.DISTRIBUTOR', fallbackLabel: 'Distributor' },
        { key: 'OTHER', label: 'fields.enm.signing_entity.options.OTHER', fallbackLabel: 'Other' },
    ],
    trackFieldValueWithAnalytics: false,
};
